import Service from './Service';

const defaultState = {
  version: '0',
  listGridView: 'grid',
  contentView: 'Submissions',
  showWysiwyg: false,
  showNodeTypes: true,
  skipUsername: false,
};

const stateKey = 'logictry.state';
let _state = {};

class Storage extends Service {
  get state() {
    return _state;
  }

  LoadState() {
    const currentState = this.__getItem(stateKey) || {};
    _state = { ...defaultState, ...currentState };
  }
  setVersion(_version) {
    _state.version = _version;
    this.__setItem(stateKey, _state);
  }
  setListGridView(_type) {
    _state.listGridView = _type;
    this.__setItem(stateKey, _state);
  }
  setShowWysiwyg(_showWysiwyg) {
    _state.showWysiwyg = _showWysiwyg;
    this.__setItem(stateKey, _state);
  }
  setShowNodeTypes(_showNodeTypes) {
    _state.showNodeTypes = _showNodeTypes;
    this.__setItem(stateKey, _state);
  }
  setContentView(_contentView) {
    _state.contentView = _contentView;
    this.__setItem(stateKey, _state);
  }
  setSkipUsername() {
    _state.skipUsername = new Date();
    this.__setItem(stateKey, _state);
  }

  __getItem(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  }
  __setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      //
    }
  }
  __removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      //
    }
  }
}

const singleton = new Storage();
singleton.LoadState();
export default singleton;
